import { getErrorAsString, IOneNoteApi, IOneNoteApiRequestOptions, IResponsePackage } from '@notes/webintegrations-common'
import { Constants } from '../Constants'
import { Log } from '../logger/Log'

export interface IUserInfoIsShoreLineFeedUser {
  isExistingUser: boolean
}

export class UserInfoApiClient {
  private oneNoteApi: IOneNoteApi
  private userInfoSettingKey: string = 'isShoreLineFeedUser'

  constructor(oneNoteApi: IOneNoteApi) {
    this.oneNoteApi = oneNoteApi
  }

  public async logIfNewShorelineFeedUser(): Promise<void> {
    try {
      const response: IResponsePackage<IUserInfoIsShoreLineFeedUser> =
      await this.oneNoteApi.performApiCall({
        url: '/userinfo/v1/setting/' + this.userInfoSettingKey,
        requestDescription: 'GetUserInfoIsShoreLineFeedUser',
        isFullUrl: false,
        urlContainsVersion: true,
      })
      if (response.parsedResponse && response.parsedResponse.isExistingUser) {
        Log.logger.info('Retrieved info from UserInfo. Existing user')
      } else {
        Log.logger.warn('The userinfo response did not contain isShoreLineFeedUser key. New User')
        await this.setExsitingShorelineFeedUserInUserInfoSettings(true)
        const flushEvent = new CustomEvent(Constants.NEW_USER_TO_ON_ECOSYSTEM_TELEMETRY_FLUSH_EVENT, { detail: { MessageId: 'isExistingShorelineFeedUser', Value: true } })
        document.dispatchEvent(flushEvent)
      }
    } catch (error) {
      Log.logger.error(`The userinfo API threw an error ${getErrorAsString(error)}`)
    }
  }

  public async setExsitingShorelineFeedUserInUserInfoSettings(isExistingUser: boolean): Promise<void> {
    try {
      const options: IOneNoteApiRequestOptions = {
        url: '/userinfo/v1/setting/' + this.userInfoSettingKey,
        requestDescription: 'SetUserInfoIsShoreLineFeedUser',
        data: JSON.stringify({
          isExistingUser: isExistingUser,
        } as IUserInfoIsShoreLineFeedUser),
        httpMethod: 'POST',
        isFullUrl: false,
        urlContainsVersion: true,
      }
      await this.oneNoteApi.performApiCall(options)

      // Logging new shoreline feed users
      Log.logger.logReportData('NewShoreLineFeedUser', false /* isCriticalEvent */)
    } catch (error) {
      Log.logger.error(`The userinfo API threw an error ${getErrorAsString(error)}`)
      return
    }
  }
}
